<style scoped> 
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="form-group">
        <label class="label required"> {{ $t("country") }} </label>
        <app-input 
            :placeholder = "$t('select_country_phd')" 
            type = "advance-search-select"
            fetch-url = "/countries/serverside/selectable-name"
            listValueField = "name"
            v-model = "selected" 
            :loaded-per-time = "5" 
            :required = "true"  
            :disabled ="is_view"
        />
    </div>
</template>
  
<script>
    export default {
        name: 'SelectSupplier',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            is_view : {
                type : Boolean,
                default : false
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>